import { Range, RangeProps } from 'rc-slider';
import 'rc-slider/assets/index.css';
import { CSSProperties } from 'react';

import { colors, scale } from '@scripts/gds';

export interface RangeSliderProp extends RangeProps {
    /** on change method */
    onChange: (values: number[]) => void;
    /** Additional class */
    railClassName?: string;
    /** Rail styles */
    railStylesProp?: CSSProperties;
    /** Track styles */
    trackStylesProp?: CSSProperties;
    /** Handle styles */
    handleStylesProp?: CSSProperties;
}

export const RangeSlider = ({
    onChange,
    railStylesProp,
    trackStylesProp,
    handleStylesProp,
    ...props
}: RangeSliderProp) => {
    const railStylesBase: CSSProperties = {
        backgroundColor: colors?.grey300,
        borderRadius: 6,
    };

    const trackStylesBase: CSSProperties = {
        backgroundColor: colors?.secondary,
        transform: 'translate(-100%, 100%) !imporant',
    };

    const handleStylesBase: CSSProperties = {
        backgroundColor: colors?.white,
        height: scale(2),
        width: scale(2),
        borderRadius: `50%`,
        border: `2px solid ${colors.textNuanceLight}`,
        boxShadow: 'none',
        marginTop: `-6px`,
    };

    const railStyles = railStylesProp || railStylesBase;
    const handleStyles = handleStylesProp || handleStylesBase;
    const trackStyles = trackStylesProp || trackStylesBase;

    return (
        <>
            <Range
                handleStyle={[handleStyles, handleStyles]}
                trackStyle={[trackStyles]}
                railStyle={railStyles}
                css={{
                    cursor: 'pointer',
                    '&.rc-slider-disabled': { background: 'transparent' },
                    '&.rc-slider-disabled .rc-slider-track': {
                        background: `${colors?.grey400} !important`,
                    },
                    '&.rc-slider-disabled .rc-slider-handle': {
                        borderColor: `${colors?.grey400} !important`,
                    },
                }}
                {...props}
                onChange={onChange}
            />
        </>
    );
};
